<template>
    <div class="form-group">
        <label v-if="label" :for="name">{{label}}</label>
        <div class="form-control-plaintext pt-3">
            <switches :id="name" :name="name" v-model="model[name]" theme="bootstrap" color="primary"
                type-bold="true" />
        </div>
        <small class="form-text text-danger" v-if="errors[name]" v-text="errors[name][0]" />
    </div>
</template>

<script>
    import Switches from 'vue-switches';

    export default {
        props: {
            label: {
                type: String
            },

            name: {
                type: String,
                required: true
            },

            model: {
                type: [Object, Array],
                required: true
            },

            errors: {
                type: [Object, Array],
                required: true
            }
        },

        components: {
            Switches
        }
    };

</script>

<style>
</style>
